import { types } from '../reducers/appAreasReducers';

// eslint-disable-next-line import/prefer-default-export
export const GetAreas = (values) => ({
  type: types.GET,
  payload: values,
});
